import {
  AUDIENCE_TYPE,
  PHONE_PATTERN,
  USER_LEVEL_TYPE,
} from 'constants/common';
import {
  EDIT_AUDIENCE_CUSTOM,
  EDIT_AUDIENCE_RETARGETING,
  EDIT_AUDIENCE_STANDARD,
  EDIT_PERSONAL_DATA_TARGETING,
} from 'routers/route-path';
import moment from 'moment';
import domainManagementService from 'services/domainManagementService';
import { snakeCase } from 'lodash';

export const checkFormAntInvalid = (form, requiredField = []) => {
  let isEmptyObjects = false;
  const errors = form
    .getFieldsError()
    .filter(({ errors }) => errors.length).length;
  if (requiredField.length) {
    const dataFields = form.getFieldsValue() || {};
    isEmptyObjects = !checkRequiredFieldHasValue(dataFields, requiredField);
  }
  return errors || isEmptyObjects;
};

/*
 @param { 1: '', 2: {3: ''} } object
 @param ['1', '3'] requiredField: array of keys in object
 @return false . Check all requiredField have value
*/
const checkRequiredFieldHasValue = (object, requiredField) => {
  if (!object || object === null) return false;
  return (
    Object.entries(object).every(([key, data]) => {
      if (data && typeof data === 'object') {
        return checkRequiredFieldHasValue(data, requiredField);
      }
      if (requiredField?.indexOf(key) !== -1) {
        return !!data;
      }
      return true;
    }) || false
  );
};

export const checkStatusSuccess = (num) => {
  return num.toString().match(/2../);
};

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};

let timer;
const DEFAULT_TIMEOUT = 300;
export const debounced = (fn, delay = DEFAULT_TIMEOUT) => {
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    fn();
    timer = null;
  }, delay);
};

export const getFileExtension = (fileName) => {
  if (!fileName) {
    return {};
  }
  const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
  const name = fileName.replace(/\.[^/.]+$/, '');
  return { extension, name };
};

export const lowerCaseKey = (info) => {
  if (!info) return;
  let obj = {};
  for (let key in info) {
    if (info.hasOwnProperty(key)) {
      const ketNew = key.toLowerCase();
      obj = Object.assign({}, obj, {
        [ketNew]: info[key],
      });
    }
  }
  return obj;
};

export const getEmailHide = (email) => {
  if (!email) {
    return '';
  }
  return `${email.substring(0, 3)}•••••${email.slice(email.length - 4)}`;
};

export const getPhoneHide = (phone) => {
  if (!phone) {
    return '';
  }
  return `•••••${phone.slice(phone.length - 4)}`;
};

export const getPhoneNumber = (phone) => {
  if (phone.charAt(0) == 0) {
    return phone.substr(1);
  }
  return phone;
};

export class ValidateRequireField {
  field = [];
  constructor(validate) {
    this.field = Object.entries(validate).reduce((acc, [key, value]) => {
      if (value.find((_) => _.required)) {
        acc.push(key);
      }
      return acc;
    }, []);
  }

  check(form) {
    const values = form.getFieldsValue(this.field);
    return Object.values(values).some((_) => !_) || checkFormAntInvalid(form);
  }
}

export const findById = (id, array) => {
  return array.find((_) => _.id === id);
};

export const sleep = (milliseconds) =>
  new Promise((resolve) => setTimeout(resolve, milliseconds));

export const convertCentToDollar = (value) => {
  if (!value) return;
  return parseInt(value) * 0.01;
};

export const startTimer = async (duration = 59, display) => {
  if (!display) display = {};
  return new Promise((resolve) => {
    let timer = duration,
      minutes,
      seconds;
    const x = setInterval(() => {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      if (+minutes) {
        display.textContent = `${minutes} : ${seconds}s`;
      } else {
        display.textContent = moment
          .utc(moment.duration(seconds, 'seconds').asMilliseconds())
          .format('mm:ss');
      }

      timer--;

      if (timer < 0) {
        display.textContent = '';
        resolve(true);
        clearInterval(x);
      }
    }, 1000);
  });
};

export const dedupe = (list) => {
  const uniq = new Set(list.map((e) => JSON.stringify(e)));

  return Array.from(uniq).map((e) => JSON.parse(e));
};

export const normFile = (e, key = 'fileList') => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e[key];
};

export const checkValidRole = ({
  userInfo,
  roles = [],
  condition,
  isPrivate,
  defaultShow = false,
  mobile = false,
}) => {
  if (!isPrivate) {
    return true;
  }
  if (isMobile) {
    return mobile;
  }
  if (userInfo) {
    const { level, manageCard } = userInfo;
    if (condition) {
      if (condition.accessWallet) {
        return (
          level === USER_LEVEL_TYPE.ADMIN ||
          (level === USER_LEVEL_TYPE.CAMPAIGN_MANAGER && manageCard)
        );
      }
      if (condition.domain) {
        const currentDomain = domainManagementService.currentDomain;
        if (!condition.domain.includes(currentDomain)) {
          return false;
        }
      }
    }
    return roles?.length > 0 ? roles.includes(level) : true;
  }
  return defaultShow;
};

export const removeDuplicatesArray = (arr) => {
  return arr.filter((item, index, self) => self.indexOf(item) == index);
};

export const checkSorterColumn = (sorter, columnName) => {
  return sorter.sortBy && sorter.sortBy === columnName
    ? sorter.sortDirection === 'desc'
      ? 'descend'
      : 'ascend'
    : false;
};

export const getAudienceTypeLink = (type = '') => {
  let linkEditAudience = '';
  switch (type) {
    case AUDIENCE_TYPE.PERSONAL_DATA:
      linkEditAudience = EDIT_PERSONAL_DATA_TARGETING;
      break;
    case AUDIENCE_TYPE.RETARGETING:
      linkEditAudience = EDIT_AUDIENCE_RETARGETING;
      break;
    // case AUDIENCE_TYPE.VOTER_FILE:
    //   linkEditAudience = EDIT_VOTER_FILE_TARGETING;
    //   break;
    default:
      linkEditAudience = EDIT_AUDIENCE_CUSTOM;
      break;
  }
  return linkEditAudience;
};

export const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

export const groupBy = (array, key) => {
  return array.reduce((acc, cur) => {
    (acc[cur[key]] = acc[cur[key]] || []).push(cur);
    return acc;
  }, {});
};

export const isProduction = process.env.REACT_APP_NODE_ENV === 'production';
export const isDev = process.env.REACT_APP_NODE_ENV === 'development';

export const calculatePercent = (percent, number) =>
  !isNaN(percent) ? (percent / 100) * number : 0;

export const generateRandomColor = () =>
  Math.floor(Math.random() * 16777215).toString(16);

export const blobUrl = (blob) => {
  if (!blob.url) {
    blob.url = URL.createObjectURL(blob);
  }
  return blob.url;
};

export const formattedDomainSites = (domain) => {
  if (!domain) return '';

  if (domain.includes(' ')) {
    if (domain.includes('App: ')) {
      return snakeCase(domain.replace('App: ', ''));
    }
    return snakeCase(domain);
  } else if (!domain.includes('com')) {
    return domain + '.com';
  }

  return domain;
};

export const getLogoComponent = (logo) => {
  if (!logo) return () => <div>Logo</div>;

  // If logo is a string (PNG path), return img element
  if (typeof logo === 'string') {
    return () => (
      <img src={logo} alt="Logo" style={{ maxWidth: '100%', height: 'auto' }} />
    );
  }

  // If logo is a React component (SVG), return it directly
  return logo;
};
